import { QuickCallModule } from './../../feature/newrequest/quickcall/quickcall.module';
import { OutagesService } from './../../feature/outages/services/outages.service';
/**
2  *  Copyright (c) 2022 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */


import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { FormsModule } from '@angular/forms';
import { HomeRouitngModule } from './home-routing.module';
import { SharedModule } from '../../../shared/shared.module';
import { ZSDTranslateService } from '../../../common/zsd-translate.service';
import { QuickCallService } from '../../feature/newrequest/quickcall/service/quickcalllist.service';
import { RequestsService } from '../../feature/requests/services/requests.service';
import { RequestslistService } from '../../feature/requests/services/requestslist.service';
import { KbaService } from '../../feature/selfhelp/services/kba.service';
import { UIMessageService } from '../../feature/shared/services/uimessages.service';
import { ReportIncidentService } from '../../feature/newrequest/reportincident/services/reportincident.service';
import { SpinnerModule } from '../../../shared/spinner/spinner.module';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HomeRouitngModule,
    SpinnerModule,
    QuickCallModule,
    SharedModule,
    ToastrModule.forRoot({
      maxOpened: 1, // Max toasts opened. Toasts will be queued. 0 is unlimited
      autoDismiss: true, // Dismiss current toast when max is reached
      timeOut: 10000,
      positionClass: 'toast-top-center'
    })
  ],
  declarations: [ HomeComponent],
  providers: [ZSDTranslateService, QuickCallService, RequestsService,
     RequestslistService, OutagesService, KbaService, UIMessageService,
     ReportIncidentService, ToastrService],
  exports : [ HomeComponent, ToastrModule ]
})
export class HomeModule { }
